<template lang="html">
    <div>
        <payment-single-row
            v-for="payment in payments"
            :isUnsavedRefund="payment.id < 0"
            :payment="payment"
            :refunds="refunds"
            :reservation="reservation"
            :key="payment.id"
            class="mb-1">
        </payment-single-row>
    </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import paymentSingleRow from './paymentSingleRow'
export default {

    props: {
        reservation:{
            type: Object
        },
        payments: {
            type: Array,
            default: function () {
                return []
            }
        },
        refunds: {
            type: Array,
            default: function () {
                return []
            }
        },
    },
    computed: {
        ...mapGetters([
            'getRefundReasons',
            'getPercentageOrCurrency'
        ])
    },
    components:{
        paymentSingleRow
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// paymentRows.vue?49fe7e74